export default "__VITE_ASSET__DvFzZ$8A__"